export enum MapStyles {
    Standard = 0,
    Monochrome = 1,
    Satellite = 2
};

export type MapIconStyle = { maxWidth: string, maxHeight: string, cursor: string, border?: string, borderRadius?: string };
const monochromeStyle =   //modified subtle gray-scale map style from: https://snazzymaps.com/style/15/subtle-grayscale
  [
    {
      "featureType": "administrative",
      "elementType": "all",
      "stylers": [
        {
          "visibility": "on"
        }
      ]
    },
    {
      "featureType": "administrative",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#484848"
        }
      ]
    },
    {
      "featureType": "landscape",
      "elementType": "geometry",
      "stylers": [
        {
          "hue": "#ff0000"
        }
      ]
    },
    {
      "featureType": "landscape",
      "elementType": "geometry.fill",
      "stylers": [
        {
          "color": "#ededed"
        },
        {
          "visibility": "off"
        },
        {
          "saturation": "-100"
        },
        {
          "lightness": "40"
        }
      ]
    },
    {
      "featureType": "landscape.man_made",
      "elementType": "all",
      "stylers": [
        {
          "visibility": "on"
        }
      ]
    },
    {
      "featureType": "landscape.natural",
      "elementType": "all",
      "stylers": [
        {
          "visibility": "on"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "all",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "poi.park",
      "elementType": "all",
      "stylers": [
        {
          "visibility": "on"
        }
      ]
    },
    {
      "featureType": "poi.park",
      "elementType": "geometry.fill",
      "stylers": [
        {
          "color": "#e6f3d6"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "geometry.fill",
      "stylers": [
        {
          "color": "#dad4d2"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "geometry.stroke",
      "stylers": [
        {
          "weight": "0.01"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "geometry.fill",
      "stylers": [
        {
          "color": "#cde9ee"
        },
        {
          "lightness": "33"
        }
      ]
    }
  ];

export const monochromeMapOptions: google.maps.MapOptions = {
    minZoom: 4,
    maxZoom: 15,
    isFractionalZoomEnabled: false,
    disableDefaultUI: true,
    zoomControl: true,
    zoom: 7,
    streetViewControl: true,
    fullscreenControl : true,
    styles: monochromeStyle,
    scrollwheel: true
  }

export const standardMapOptions: google.maps.MapOptions = {
    minZoom: 4,
    maxZoom: 16,
    //mapId: "8d1b0abc1c376581",
    isFractionalZoomEnabled: false,
    fullscreenControl: true,
    disableDefaultUI: true,
    zoomControl: true,
    streetViewControl: true,
    styles: [],
    mapTypeId: 'roadmap',
    scrollwheel: true
  };

  export const satelliteMapOptions: google.maps.MapOptions = {
    minZoom: 4,
    maxZoom: 16,
    //mapId: "8d1b0abc1c376581",
    isFractionalZoomEnabled: false,
    fullscreenControl: false,
    disableDefaultUI: true,
    zoomControl: true,
    streetViewControl: true,
    styles: [],
    mapTypeId: 'hybrid'
  };
